import React from 'react';
import { Link } from '@mui/material';
import usePrequalMerchant from './usePrequalMerchant';
import { standardizePhone } from '../../utils/phone';

const MaybeMerchantPhone = () => {
  const { data: merchant } = usePrequalMerchant();

  if (!merchant?.service_phone) {
    return '';
  }

  const { formatted, normalized } = standardizePhone(merchant.service_phone);
  return (
    <>
      {' '}
      at
      {' '}
      <Link href={`tel:${normalized}`}>{formatted}</Link>
    </>
  );
};

const DeclinedMerchantCopy = () => {
  const { data: merchant } = usePrequalMerchant();
  return (
    <>
      Please contact
      {' '}
      {merchant?.name || 'your merchant'}
      <MaybeMerchantPhone />
      {' '}
      for additional options. You will receive an email shortly with more information.
    </>
  );
};

export default DeclinedMerchantCopy;
